/**
 * Kiosk setup codes (#2691): `ks1_` plus 43 base64url characters, issued once
 * by Front desk › Devices and valid for 15 minutes. Staff can show it as text,
 * as a QR of the code, or as a link to `/kiosk#code=…`; all three end here.
 */
const SETUP_CODE = /^ks1_[A-Za-z0-9_-]{43}$/;
const EMBEDDED_CODE = /ks1_[A-Za-z0-9_-]{43}(?![A-Za-z0-9_-])/;

export function isSetupCode(value: string): boolean {
  return SETUP_CODE.test(value);
}

/**
 * The setup code inside typed text, a scanned QR or a setup link, or null.
 * Whitespace a person adds while typing is ignored.
 */
export function parseSetupCode(raw: string | null | undefined): string | null {
  if (!raw) return null;
  const compact = raw.trim().replace(/\s+/g, "");
  if (isSetupCode(compact)) return compact;
  const embedded = EMBEDDED_CODE.exec(compact);
  return embedded ? embedded[0] : null;
}

/** The setup code carried in a `#code=` fragment, or null. */
export function setupCodeFromHash(hash: string): string | null {
  const params = new URLSearchParams(hash.replace(/^#/, ""));
  return parseSetupCode(params.get("code"));
}
